import type * as React from "react";

import {useGql, type GqlFetchFn} from "@khan/data-gql";

type Props = {
    children: (arg1: GqlFetchFn) => React.ReactNode;
};

export default function Gql(props: Props): React.ReactElement {
    // @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
    return props.children(useGql());
}
